"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConflictError = void 0;
class ConflictError extends Error {
    constructor(message) {
        super(message);
        this.className = "ConflictError";
        this.message = "";
        this.message = message;
    }
}
exports.ConflictError = ConflictError;
//# sourceMappingURL=ConflictError.js.map